<template>
    <div class="roma-page-content fill-height grey lighten-4">
        <!-- cambiando modo nueva clase / listado de clases -->
        <template>
            <FilterLesson :mode="false" />
            <LessonsList :items="lessons" />
        </template>

        <RomaBottomNav>
            <!-- <v-col class="text-center">
                <v-btn icon small fab>
                    <v-icon>
                        icon-download
                    </v-icon>
                </v-btn>
            </v-col> -->
            <v-col class="d-flex align-center justify-center">
                <v-btn
                    color="accent"
                    class="text-capitalize"
                    :to="{ name: 'NewLesson' }"
                    rounded
                    medium
                >
                    <span class="btn-text">
                        Nueva clase
                    </span>
                </v-btn>
            </v-col>
            <v-col class="text-center">
                <v-btn icon small fab @click="toggleGridColumnsLesson()">
                    <template v-if="!getGridColumnLesson">
                        <v-icon>
                            card-mode
                        </v-icon>
                    </template>
                    <template v-else>
                        <v-icon>
                            list-mode
                        </v-icon>
                    </template>
                </v-btn>
            </v-col>
        </RomaBottomNav>
    </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
import FilterLesson from "@/components/lesson/RomaFilterLesson.vue";
import LessonsList from "@/components/lesson/RomaLessonsList.vue";
import RomaBottomNav from "@/components/commons/RomaBottomNav";
export default {
    data() {
        return {
            buttonOptions: {
                title: "Nueva Clase",
                icon: "mdi-plus",
                color: "accent"
            }
        };
    },
    components: {
        FilterLesson,
        LessonsList,
        RomaBottomNav
    },
    async mounted() {
        this.setLayout("main-layout");
        this.changeLessonActive("TODAS");
        this.actionGetLessons({ pageNumber: 0, pageSize: 12 });
        await this.actionGetInformationLesson(this.getInstitutionId);
    },
    computed: {
        ...mapGetters({
            layout: "getLayout",
            lessons: "getLessons",
            getGridColumnLesson: "getGridColumnLesson",
            getLessonActive: "getLessonActive",
            getInstitutionId: "getInstitutionId"
        }),
        getContent() {
            return this.lessons ? this.lessons.content : [];
        }
    },
    watch: {
        getLessonActive(val) {
            let filter = null;

            if (val == "ACTIVAS") {
                filter = "ACTIVO";
            } else if (val == "INACTIVAS") {
                filter = "INACTIVO";
            }

            this.actionGetLessons({ pageNumber: 0, stateFilter: filter });
        }
    },
    methods: {
        ...mapActions({
            setLayout: "setLayout",
            toastSuccess: "toastSuccess",
            toastError: "toastError",
            actionGetLessons: "actionGetLessons",
            toggleGridColumnsLesson: "toggleGridColumnsLesson",
            changeLessonActive: "changeLessonActive",
      		actionGetInformationLesson: "actionGetInformationLesson"
        })
    }
};
</script>

<style lang="scss"></style>
